import type { DecoratedOrderProduct } from '@witmetrics/utils';
import { ORDER_PRODUCT_STATUS_ID } from '@witmetrics/utils/constants';

const { COMPLETE } = ORDER_PRODUCT_STATUS_ID;

export const classes = {
  card: 'px-0 py-0',
  list: 'w-full py-0',
  toggle: 'mr-4',
  toggleOption: 'py-1',
};

export function filterProducts(
  orderProducts: DecoratedOrderProduct[],
  showAll: boolean
) {
  if (showAll) return orderProducts;
  return orderProducts.filter((op) => op.orderProductStatusId !== COMPLETE);
}
